function runWhenInit() {
    //console.log("The current cart state is: ", window.liquidAjaxCart.cart);
    window.liquidAjaxCart.conf('updateOnWindowFocus', false);
    validateLogout();
  
    //runWhenInitEvent();
  }
  if (window.liquidAjaxCart?.init) {
    // if Liquid Ajax Cart is already initialized
    runWhenInit();
  } else {
    // wait for Liquid Ajax Cart to be initialized
    document.addEventListener("liquid-ajax-cart:init", runWhenInit);
  }
  
  /* UPDATE CART END REQUEST */
  document.addEventListener('liquid-ajax-cart:request-end', event => {
    const {requestState} = event.detail;
  
    // If the "add to cart" request is successful
    if (requestState.requestType === 'add' && requestState.responseData?.ok) {
      // Add the CSS class to the "body" tag
      openCart(event);

      const modalQuckadd = document.querySelector('quick-add-modal[open]');
      if(modalQuckadd){
        modalQuckadd.removeAttribute('open');
      }
    }
    
    closeCart();

    console.log('pasa y validad', sessionStorage.getItem('member-cart'));
    const isMember = sessionStorage.getItem('member-cart');
    
    changeNotification();
    validateShowCart(isMember);
  
    
  
  });
  
  function changeNotification() {
    const updateNotification = document.querySelectorAll('[data-count-cart]');

    if(!updateNotification) return;
  
    updateNotification.forEach(el => {
      el.textContent = window.liquidAjaxCart.cart.item_count
    });
  }
  
  function validateShowCart(isMember) {
    if (isMember === 'true') {
  
      const cartContent = document.querySelector('.cart-drawer__container');
      const cartSub = document.querySelector('.cart-drawer__subhead');
      const cartUpsell = document.querySelector('.cart-drawer__upsell');
  
      if (cartContent) cartContent.classList.add('is-member');
      if (cartSub) cartSub.classList.add('hide');
      if (cartUpsell) cartUpsell.classList.remove('hide');
    }
  }
  
  
  function closeCart() {
    const buttonClose = document.querySelector('.js-cart-close');
    const overlayClose = document.querySelector('.overlay-js');
  
    overlayClose.addEventListener('click', () => {
      restart();
    })
    buttonClose.addEventListener('click', () => {
      restart();
    });
  }
  
  function openCart(event) {
    event.preventDefault();
    document.body.classList.add('js-show-ajax-cart');
    document.querySelector('body').style.overflow = 'hidden';
  }
  
  function restart() {
    document.body.classList.remove('js-show-ajax-cart');
    document.body.style.overflow = 'scroll';
  }
  
  function validateLogout() {
  
    const linkLogout = document.querySelector('.logout-link');
  
    if (linkLogout) {
      linkLogout.addEventListener('click', () => {
        liquidAjaxCart.clear({}, {});
  
        setTimeout(()=> {
          window.location.href = '/account/logout'
        }, 500)
      }) 
   }
  }
  
  
  /* event custom */
  document.addEventListener('DOMContentLoaded', () => {
  
    closeCart();
  
    /* event listener */
  
    /* BUTTON OPEN CART */
    const buttonsOpen = document.querySelectorAll('.js-button-cart');
    
    buttonsOpen.forEach((button) => {
      button.addEventListener('click', openCart)
    })
    
    /* END BUTTON OPEN CART */
  
  });
  